import { render, staticRenderFns } from "./setting-online-whiteList.vue?vue&type=template&id=24d20d78&"
import script from "./setting-online-whiteList.vue?vue&type=script&lang=js&"
export * from "./setting-online-whiteList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports